import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import ls from 'local-storage';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Input,
  Label,
  InputGroupAddon,
  Button,
  Table,
} from 'reactstrap';
import qs from 'query-string';

import authProtection from '../../HOCs/authProtection';

import withAlertTimeout from '../../HOCs/withAlertTimeout';

import CreateAUser from '../Components/CreateAUser';
import generatePassword from '../../helpers/generatePassword';
import UserAttachment from '../Components/UserAttachment';

//todo delete all unused imports above once i have working product

const PoweredPending = props => {
  const [password, setPassword] = useState('');
  const [user, setUser] = useState({
    fullName: '',
    username: '',
    email: '',
    password: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [generatedUser, setGeneratedUser] = useState(
    ls.get('onboardedUser') || {}
  );
  const [businessSearch, setBusinessSearch] = useState({
    businessName: '',
    businessCity: '',
    isSearching: false,
  });
  const [businessResults, setBusinessResults] = useState([]);

  useEffect(() => {
    // const user = JSON.parse(sessionStorage.getItem('user'));
    // if (
    //   user.privyData.group.goNation.some(item => item.name === 'SuperAdmin')
    // ) {
    //   this.isSuperAdmin = true;
    // }
    setUser({
      ...user,
      password: generatePassword(),
    });
  }, []);

  const onCreateUser = () => {
    setIsSubmitting(true);
    const { username, email, password, fullName } = user;
    const userObject = {
      provider: 'Gonation',
      username: username,
      email: email.toLowerCase(),
      password: password,
      tncAcceptance: true,
      fullname: fullName,
    };
    axios
      .post(`api/proxy/v2/users`, userObject)
      .then(res => {
        console.log('the req i got was: ', res);
        setSuccessMessage(
          'User created successfully. Email confirmation link sent.',
          props.showSuccess()
        );
        setGeneratedUser(res.data);
        ls.set('onboardedUser', res.data);
        setIsSubmitting(false);
      })
      .catch(error => {
        setIsSubmitting(false);
        setErrorMessage(error.response.data.error, props.showFailure());
      });
  };

  const onUserChange = e => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  const renderConnection = () => {
    return (
      <div>
        <p>
          Let's get {generatedUser.displayName} connected to their business.
        </p>
        <UserAttachment
          setBusinessSearch={setBusinessSearch}
          businessSearch={businessSearch}
          handleBusinessSearch={handleBusinessSearch}
          businessResults={businessResults}
          handleBusinessClick={handleBusinessClick}
        />
      </div>
    );
  };

  const handleBusinessSearch = () => {
    setBusinessSearch({
      ...businessSearch,
      isSearching: true,
    });
    const token = sessionStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };
    const query = {};
    if (businessSearch.businessName) {
      query.name = businessSearch.businessName;
    }

    if (businessSearch.businessCity) {
      query.geofence = businessSearch.businessCity;
    }

    // todo refactor out the isSearching: false's
    axios
      .get(`/api/proxy/v2/businesses?${qs.stringify(query)}`, headers)
      .then(({ data }) => {
        setBusinessResults(data.items);
        setBusinessSearch({
          ...businessSearch,
          isSearching: false,
        });
      })
      .catch(error => {
        setErrorMessage(error.response.data.error, props.showFailure());
        setBusinessSearch({
          ...businessSearch,
          isSearching: false,
        });
      })
      .finally(() => {
        setBusinessSearch({
          ...businessSearch,
          isSearching: false,
        });
      });
  };
  const token = sessionStorage.getItem('token');

  // const autoApproveClaim = () => {
  //   const { id } = generatedUser;
  //   console.log('looking for claim with ID of: ', id);
  //   axios
  //     .post(
  //       `/api/proxy/v2/businesses/claim/control`,
  //       { id, accepted: true },
  //       { headers: { Authorization: `Bearer ${token}` } }
  //     )
  //     .then(() => {
  //       // this.closeClaim(id);
  //       alert('claim approved');
  //       props.showSuccess('Claim Approved');
  //       // this.fetchClaims();
  //     })
  //     .catch(err => {
  //       console.log(err);
  //       props.showFailure();
  //     });
  // };

  const handleBusinessClick = id => {
    //todo make this param dynamic (Business owner / Manager)
    const params = {
      name: 'BusinessOwner',
      entityId: id,
    };
    axios
      .put(
        `api/proxy/v2/users/${generatedUser.id}/permisgroups/invite`,
        params,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        console.log('Sent invite for claim... ', res);
        // Once invite is sent we must auto approve it instantly.
      })
      .catch(e => console.log('error when creating claim', e));
  };

  const { success, failure } = props;
  return (
    <React.Fragment>
      <h1>power pending</h1>
      {generatedUser.id ? (
        renderConnection()
      ) : (
        <CreateAUser
          success={success}
          successMessage={successMessage}
          failure={failure}
          errorMessage={errorMessage}
          user={user}
          onUserChange={onUserChange}
          isSubmitting={isSubmitting}
          onCreateUser={onCreateUser}
        />
      )}
    </React.Fragment>
  );
};

export default authProtection(withAlertTimeout(PoweredPending));



// WEBPACK FOOTER //
// ./src/views/Pages/PoweredPending.js